// import { HttpInterceptorFn } from '@angular/common/http';
// import { inject } from '@angular/core';
// import { finalize } from 'rxjs';
// import { LoadingService } from '../services/loading.service';
// import { environment } from '../../../environments/environment';

// export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
//   const loading = inject(LoadingService);

//   // Ignorar endpoints de sessão
//   const ignoredEndpoints = [
//     '/api/auth/login',
//     '/api/auth/logout',
//     '/api/auth/validate',
//     '/usuarios'
//   ];

//   const isIgnored = ignoredEndpoints.some(url =>
//     req.url.includes(url)
//   );

//   if (!req.url.startsWith(environment.apiUrl) || isIgnored) {
//     return next(req);
//   }

//   loading.show();

//   return next(req).pipe(
//     finalize(() => loading.hide())
//   );
// };
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';
import { environment } from '../../../environments/environment';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loading = inject(LoadingService);

  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  const methodsWithLoading = ['POST', 'PUT', 'DELETE', 'PATCH'];
  if (!methodsWithLoading.includes(req.method)) {
    return next(req);
  }

  loading.show();

  return next(req).pipe(
    finalize(() => loading.hide())
  );
};
